/* suite.io — App Registry
   Each app: {id, name, description, icon, color, navItems}
   Homepage reads this, filters by user's apps array, renders grid. */

export const APP_REGISTRY = [
  {
    id: "jobs",
    name: "Jobs",
    description: "Quotes, booking, production pipeline",
    color: "text",       // C.text
    iconClass: "jobs",
    // Schedule (holds, 2026-09-04): the month view, open to every role; JobsApp
    // routes by label, so the position carries no meaning.
    navItems: ["Dashboard", "Schedule", "Quotes", "Jobs", "Insights"],
  },
  {
    id: "crm",
    name: "CRM",
    description: "Contacts and client accounts",
    color: "blue",
    iconClass: "crm",
    // Ported from legacy 2026-08-26; the first tab was called People until CRM
    // v3 slice 3 renamed it. Campaigns landed in slice 5; Segments (slice 4)
    // goes between Clients and Campaigns, and Content (slice 6) after it, for
    // the final order Contacts, Clients, Segments, Campaigns, Content. Inbox,
    // Assistant and Tasks are retired.
    // CrmApp routes by LOOKING THE LABEL UP in this array, never by a hard
    // coded index, so inserting Segments here is the whole change slice 4
    // needs to make.
    navItems: ["Contacts", "Clients", "Segments", "Campaigns"],
  },
  {
    id: "ingest",
    name: "Ingest",
    description: "Capture ingestion, file management",
    color: "green",
    iconClass: "ingest",
    // Ingest's nav is its in-page two-card fork (IngestHome) — one topbar item
    // whose click returns to the front door, like Jobs returning to its list.
    navItems: ["Ingest"],
  },
  {
    id: "sheets",
    name: "Preview Sheets",
    description: "Preview sheets, photo grids, 3D renders",
    color: "purple",
    iconClass: "sheets",
    // Templates tab dropped 2026-06-12 (Ivin) — presets + rotation editing live
    // inside the picker screens, not a separate home. Badge comes off when v1 ships.
    navItems: ["Sheets"],
    badge: { text: "coming soon", variant: "dev" },
  },
  {
    id: "autocycle",
    name: "AutoCycle",
    description: "Processing pipelines, photogrammetry",
    color: "amber",
    iconClass: "autocycle",
    navItems: ["Queue", "Processing", "History"],
    badge: { text: "coming soon", variant: "dev" },
  },
  {
    id: "website",
    name: "Website",
    description: "Planner sessions, prospect pipeline, feedback",
    color: "teal",
    iconClass: "website",
    navItems: ["Prospects", "Feedback", "Settings"],
  },
  {
    id: "resources",
    name: "Resources",
    description: "Equipment specs, software docs, manuals",
    color: "stone",
    iconClass: "resources",
    navItems: ["Equipment", "Software", "Manuals"],
  },
  {
    id: "traffic",
    name: "Traffic Control",
    description: "Studio file orchestration — transfers, backups, purge control",
    color: "danger",
    iconClass: "traffic",
    // Machines first — the only live tab (NYC Bridge fleet, woken
    // 2026-06-11); the rest are placeholders until TC's brain is built.
    navItems: ["Machines", "Studio Map", "Transfers", "Backups"],
  },
  {
    id: "safeshare",
    name: "SafeShare",
    description: "Client delivery portal \u2014 secure file transfer, client vaults",
    color: "indigo",
    iconClass: "safeshare",
    navItems: ["Deliveries", "Client Vaults", "Settings"],
    badge: { text: "future", variant: "future" },
  },
  {
    // Tile shows for all admins; ACCESS is the server-side finAuth grant +
    // financials passphrase, never tile-hiding (mockups/financials-v1.html,
    // approved 2026-08-25).
    id: "financials",
    name: "Financials",
    description: "QuickBooks \u2014 P&L, invoices, cash position",
    color: "brown",
    iconClass: "financials",
    navItems: ["Overview", "Invoices", "Expenses", "Reports", "Settings"],
  },
];

export const getApp = (id) => APP_REGISTRY.find((a) => a.id === id);
